/* MEGO TOYS — Theme JS v4.0 */

// ── LANGUAGE ──
function mgLang() {
  var h = document.documentElement;
  var isRTL = h.getAttribute('dir') === 'rtl';
  var btn = document.getElementById('lang-label');
  var localeInput = document.getElementById('mg-locale-code');
  var localeForm = document.getElementById('mg-locale-form');

  if (isRTL) {
    // Switch to EN
    if (localeInput) localeInput.value = 'en';
    if (btn) btn.textContent = '🇪🇬 عربي';
  } else {
    // Switch to AR
    if (localeInput) localeInput.value = 'ar';
    if (btn) btn.textContent = '🇬🇧 EN';
  }

  // If Shopify locale form exists, submit it (changes checkout language too)
  if (localeForm) {
    localeForm.submit();
  } else {
    // Fallback: DOM-only toggle for stores without multi-language enabled
    if (isRTL) {
      h.setAttribute('dir','ltr'); h.setAttribute('lang','en');
      localStorage.setItem('mg_lang','en');
    } else {
      h.setAttribute('dir','rtl'); h.setAttribute('lang','ar');
      localStorage.setItem('mg_lang','ar');
    }
  }
}
(function(){
  // Sync DOM direction with Shopify locale on page load (server-side lang already set in <html>)
  var htmlLang = document.documentElement.getAttribute('lang') || 'en';
  var btn = document.getElementById('lang-label');
  if (htmlLang === 'ar') {
    document.documentElement.setAttribute('dir','rtl');
    if (btn) btn.textContent = '🇬🇧 EN';
  } else {
    document.documentElement.setAttribute('dir','ltr');
    if (btn) btn.textContent = '🇪🇬 عربي';
  }
})();

// ── SEARCH ──
function mgSearch() {
  var b = document.getElementById('search-bar');
  if(!b) return;
  b.classList.toggle('open');
  if(b.classList.contains('open')) {
    var i = b.querySelector('input');
    if(i) setTimeout(function(){i.focus();},80);
  }
}

// ── MOBILE NAV ──
function mgMenu() {
  var n = document.getElementById('mobile-nav');
  if(n) n.classList.toggle('open');
}

// ── STICKY HEADER ──
window.addEventListener('scroll', function(){
  var h = document.querySelector('.site-header');
  if(h) h.classList.toggle('scrolled', window.scrollY > 50);
}, {passive:true});

// ── CART ──
var mgCartItems = [];

function mgOpenCart() {
  document.getElementById('cart-overlay').classList.add('open');
  document.getElementById('cart-drawer').classList.add('open');
  document.body.style.overflow = 'hidden';
  if(window.Shopify) mgFetchCart();
}
function mgCloseCart() {
  document.getElementById('cart-overlay').classList.remove('open');
  document.getElementById('cart-drawer').classList.remove('open');
  document.body.style.overflow = '';
}

// Shopify AJAX cart
function mgFetchCart() {
  fetch('/cart.js').then(function(r){return r.json();}).then(function(c){mgRenderCart(c);}).catch(function(){});
}

function mgRenderCart(cart) {
  var count = cart.item_count || 0;
  document.querySelectorAll('.cart-badge').forEach(function(el){el.textContent=count;});
  var total = cart.total_price || 0;
  var totalFmt = 'EGP ' + (total/100).toLocaleString();
  var ta = document.getElementById('cart-total-amount');
  if(ta) ta.textContent = totalFmt;
  var foot = document.getElementById('cart-foot');
  var emp = document.getElementById('cart-empty');
  var items = document.getElementById('cart-items');
  if(count === 0){
    if(foot) foot.style.display='none';
    if(emp) emp.style.display='block';
    if(items) items.innerHTML='';
    return;
  }
  if(foot) foot.style.display='block';
  if(emp) emp.style.display='none';
  // Shipping bar
  var threshold = 50000;
  var pct = Math.min((total/threshold)*100,100);
  var fill = document.getElementById('ship-fill');
  if(fill) fill.style.width = pct+'%';
  var rem = Math.max(0,(threshold-total)/100);
  var rt = document.getElementById('ship-remain');
  if(rt) rt.textContent = rem.toLocaleString();
  if(items && cart.items) {
    items.innerHTML = cart.items.map(function(item){
      var lp = 'EGP '+(item.final_line_price/100).toLocaleString();
      var img = item.image ? '<img src="'+item.image+'" alt="">' : '<span style="font-size:26px">🧸</span>';
      return '<div class="cart-item-row">'+
        '<div class="cart-item-img">'+img+'</div>'+
        '<div class="cart-item-info">'+
          '<div class="cart-item-name">'+item.product_title+'</div>'+
          (item.variant_title && item.variant_title!=='Default Title'?'<div class="cart-item-variant">'+item.variant_title+'</div>':'')+
          '<div class="cart-item-bottom">'+
            '<div class="cart-item-price">'+lp+'</div>'+
            '<div class="cart-qty">'+
              '<button onclick="mgQty('+item.variant_id+','+(item.quantity-1)+')">−</button>'+
              '<span>'+item.quantity+'</span>'+
              '<button onclick="mgQty('+item.variant_id+','+(item.quantity+1)+')">+</button>'+
            '</div>'+
          '</div>'+
        '</div>'+
      '</div>';
    }).join('');
  }
}

function mgQty(vid, qty) {
  var u={}; u[vid]=qty;
  fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates:u})})
  .then(function(r){return r.json();}).then(function(c){mgRenderCart(c);}).catch(function(){});
}

function mgQuickAdd(btn, vid, name, price) {
  var orig = btn.innerHTML;
  btn.innerHTML='<span class="en">Adding...</span><span class="ar">جارٍ الإضافة...</span>';
  btn.disabled=true;
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:vid,quantity:1})})
  .then(function(r){return r.json();})
  .then(function(){
    btn.innerHTML='<span class="en">✓ Added!</span><span class="ar">✓ تمت الإضافة!</span>';
    btn.style.background='var(--green)';
    mgFetchCart(); mgOpenCart();
    setTimeout(function(){btn.innerHTML=orig;btn.style.background='';btn.disabled=false;},2000);
  }).catch(function(){btn.innerHTML=orig;btn.disabled=false;});
}

// Demo cart (when no real products)
var _demo = [];
function mgDemoAdd(btn, name, price, emoji) {
  var ex=_demo.find(function(i){return i.name===name;});
  if(ex){ex.qty++;}else{_demo.push({name:name,price:price,emoji:emoji,qty:1});}
  var cnt=_demo.reduce(function(s,i){return s+i.qty;},0);
  document.querySelectorAll('.cart-badge').forEach(function(el){el.textContent=cnt;});
  var orig=btn.innerHTML; btn.innerHTML='✓'; btn.style.background='var(--green)';
  setTimeout(function(){btn.innerHTML=orig;btn.style.background='';},1400);
  mgRenderDemo(); mgOpenCart();
}
function mgDemoQty(name,d){
  var i=_demo.find(function(x){return x.name===name;});
  if(!i)return; i.qty+=d;
  if(i.qty<=0)_demo=_demo.filter(function(x){return x.name!==name;});
  var cnt=_demo.reduce(function(s,i){return s+i.qty;},0);
  document.querySelectorAll('.cart-badge').forEach(function(el){el.textContent=cnt;});
  mgRenderDemo();
}
function mgRenderDemo(){
  var tot=_demo.reduce(function(s,i){return s+i.price*i.qty;},0);
  var ta=document.getElementById('cart-total-amount');
  if(ta)ta.textContent='EGP '+(tot/100).toLocaleString();
  var foot=document.getElementById('cart-foot');
  var emp=document.getElementById('cart-empty');
  var items=document.getElementById('cart-items');
  if(_demo.length===0){if(foot)foot.style.display='none';if(emp)emp.style.display='block';if(items)items.innerHTML='';return;}
  if(foot)foot.style.display='block';if(emp)emp.style.display='none';
  if(items)items.innerHTML=_demo.map(function(item){
    var lp='EGP '+(item.price*item.qty/100).toLocaleString();
    return '<div class="cart-item-row">'+
      '<div class="cart-item-img" style="font-size:26px">'+item.emoji+'</div>'+
      '<div class="cart-item-info">'+
        '<div class="cart-item-name">'+item.name+'</div>'+
        '<div class="cart-item-bottom">'+
          '<div class="cart-item-price">'+lp+'</div>'+
          '<div class="cart-qty">'+
            '<button onclick="mgDemoQty(\''+item.name+'\',-1)">−</button>'+
            '<span>'+item.qty+'</span>'+
            '<button onclick="mgDemoQty(\''+item.name+'\',1)">+</button>'+
          '</div>'+
        '</div>'+
      '</div>'+
    '</div>';
  }).join('');
}

// ── INIT ──
document.addEventListener('DOMContentLoaded', function(){
  if(window.Shopify) mgFetchCart();
  document.addEventListener('keydown',function(e){if(e.key==='Escape'){mgCloseCart();}});
});
